<template>
    <div class="iframe-box">
        <a-alert message="本页面建议使用360极速浏览器或Microsoft Edge最新版本，浏览效果更佳。" :closable="true" :banner="true" type="info" />
        <bkNav fontColor="yl" searchStyle="brand" :showSearch="true"
            @bkSearchShow="bkSearchShow" @bkSearchHide="bkSearchHide"
        ></bkNav>
        
        <a-spin :spinning="spinning" size="large">
            <!-- <div :class="bkSearchTabShow?'text-span cur':'text-span'">
                <span @click="textAnalysis()"><a src="javascript:;">文本分析</a></span> |
                <span><a src="javascript:;">远读</a></span> |
                <span><a src="javascript:;">实体标注</a></span>
            </div> -->
            <div :class="bkSearchTabShow?'ifeames cur':'ifeames'">
                <iframe id="ifra" width="100%" height="715" 
                    :src="'https://dhc.library.sh.cn/iiifweb/view.html?manifest='+manifest">
                </iframe>
            </div>
        </a-spin>
    </div>
</template>

<script>
import bkNav from './../nav2'
export default {
    components:{
        bkNav
    },
    data(){
        return{
            manifest: '',
            // 全文跳转时
            manifestTitle   : '', // 广告题名
            manifestCreator : '', // 广告发布者
            manifestDate    : '', // 创建时间
            manifestDes     : '', // 文献来源
            manifestImgUrl  : '', // 图片tif
            advertisementUri: '', // 广告uri
            advertisementData: {},// 广告数据
            bkSearchTabShow: false,
            spinning: false,      // 加载中...
        }
    },
    created(){
        this.$nextTick(()=>{
            this.spinning = true;
            this.getManifest();
        })
    },
    updated(){

    },
    mounted(){
        this.$nextTick(()=>{
            this.iframeEndLoading();
        //     this.manifestAdd();
            // 监听iframe中所有点击事件
            this.onListenerAllClick(this);
        })
    },
    computed:{
        manifestParams(){ // this.manifest,
            return {
                "title": this.manifestTitle,
                "creator": this.manifestCreator,
                "date": this.manifestDate,
                "attribution": "上海图书馆",
                "description": this.manifestDes,
                "license": "http://creativecommons.org/licenses/by-sa/3.0/",
                "logo": "http://gj.library.sh.cn/gjxz/res/images/lib/shllogo.png",
                "images": [
                    {
                        "id": this.manifestImgUrl,
                        "title": this.manifestTitle,
                    }
                ]
            }
        }
    },
    methods:{
        // textAnalysis(){
        //     this.$router.push("/bk/textAnalysis");
        //     // this.$router.push({name:"literature", params:{iframeIndex: 1}});
        // },
        getManifest(){
            this.advertisementData = this.$qs.parse(localStorage.advertisementData);
            this.advertisementUri = this.getUrlParam('adUri'); // 获取地址栏参数值
            if(this.isEmpty(this.advertisementUri)) this.advertisementUri = this.advertisementData['@id'];
            this.manifestGet();
        },
        createManifest(){ // 生成manifest
            let _this = this;
            $.ajax({ 
                type : 'POST', 
                contentType: "application/json", 
                dataType:"json",
                data : JSON.stringify(this.manifestParams), 
                url : this.bkCommon.createManifestUrl + "?key=47896d7fd3c34744abb0cf258b887be2f88a20fd9fd14a4394ff8b9c53938a2e", 
                success : function(data) { 
                    console.log(data);
                }, 
                error : function(data) { 
                    // alert(JSON.stringify(data));
                }, 
                complete : function(data) {
                    _this.manifest = data.responseText;
                    _this.manifestAdd();
                } 
            });
        },
        manifestGet(){ // 获取manifest
            let params = {
                uri: this.advertisementUri
            }
            this.$axios.get( this.bkCommon.manifestGetUrl, {params: params})
            .then((res) => {
                let resultData = res.data;
                this.manifest  = resultData.manifest;
                if( this.isEmpty(this.manifest) ){
                    this.manifestTitle   = this.advertisementData.title;   // 广告题名
                    this.manifestCreator = this.arrayToString(this.advertisementData.publisher, 'publisher', ' '); // 广告发布者
                    this.manifestDate    = this.advertisementData.sj.year; // 创建时间
                    this.manifestDes     = this.advertisementData.source;  // 文献来源
                    this.manifestImgUrl  = this.advertisementData.imgUrl.split('.tif/')[0]+'.tif'; // 图片tif
                    this.createManifest();
                }
            })
            .catch((err) => {
                console.error(err)
            });
        },
        manifestAdd(){ // 保存manifest
            let params = {
                uri: this.advertisementUri,
                manifest: this.manifest
            }
            this.$axios.post( this.bkCommon.manifestAddUrl, this.$qs.stringify(params))
            .then((res) => {
                let resultData = res.data;
                // console.log(resultData);
            })
            .catch((err) => {
                console.error(err)
            });
        },
        iframeEndLoading(){ // 加载结束
            var _this = this
            const iframe = document.querySelector('#ifra')
            // 处理兼容行问题
            if (iframe.attachEvent) {
                iframe.attachEvent('onload', function () {
                    // iframe加载完毕以后执行操作
                    _this.spinning = false;
                    // R图标事件重写
                    _this.iiifR(_this);
                })
            } 
            else {
                iframe.onload = function () {
                    // iframe加载完毕以后执行操作
                    _this.spinning = false;
                    // R图标事件重写
                    _this.iiifR(_this);
                }
            }
        },
        bkSearchShow(visible){ // 高级检索展开
            this.bkSearchTabShow = visible;
            this.unScroll(); // 禁止滚动条滚动
        },
        bkSearchHide(visible){ // 高级检索关闭
            this.bkSearchTabShow = visible;
            this.removeUnScroll(); // 移除禁止滚动条滚动
        }
    }
}
</script>

<style lang="less" scoped>
.iframe-box{
    width: 100%;
    min-height: calc(100vh);
    background:#e3e3e3;
    .text-span{
        width: 90%;
        text-align: right;
        margin: 0 auto;
        margin-bottom: 10px;
        font-size: 12px;
        &.cur{
            opacity: 0.1;
        }
    }
    .ifeames{
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin: 0 auto;
        border-radius: 15px;
        &.cur{
            opacity: 0.1;
        }
        iframe{
            border: none;
        }
    }
}
</style>